import { useTranslation } from "react-i18next";

export default function Werkwijze() {
  const { t } = useTranslation("glas-vervangen");
  const steps = t("werkwijze.steps", { returnObjects: true }) as Array<{
    nr: string;
    title: string;
    desc: string;
  }>;

  return (
    <section className="bg-brand-cream py-16 md:py-24 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight text-center mb-12 md:mb-20">
          {t("werkwijze.h2")}
        </h2>

        <div className="relative max-w-[900px] mx-auto">
          {/* Yellow line - desktop horizontal */}
          <div className="hidden md:block absolute top-5 left-[12.5%] right-[12.5%] h-1 bg-brand-yellow rounded-full"></div>
          {/* Yellow line - mobile vertical */}
          <div className="md:hidden absolute top-0 bottom-0 left-5 w-1 bg-brand-yellow rounded-full"></div>

          <div className="flex flex-col md:flex-row gap-10 md:gap-6">
            {steps.map((step, i) => (
              <div
                key={i}
                className="relative flex-1 flex md:flex-col items-start md:items-center gap-4 md:gap-5 pl-12 md:pl-0"
              >
                {/* Circle */}
                <div className="absolute left-0 md:static md:mb-0 w-10 h-10 rounded-full bg-brand-blue flex items-center justify-center flex-shrink-0 z-10">
                  <span className="font-geist-mono font-bold text-sm text-white">
                    {step.nr}
                  </span>
                </div>

                <div className="flex flex-col md:text-center">
                  <h3 className="font-geist font-bold text-lg md:text-xl text-brand-text mb-1.5">
                    {step.title}
                  </h3>
                  <p className="font-geist text-sm md:text-base text-brand-text/70 leading-relaxed">
                    {step.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}